export const SET_TIPS = "SET_TIPS";
export const SET_TIPS_DELETE = "SET_TIPS_DELETE";
